module.exports = __webpack_public_path__ + "static/media/girls_who_code.ec721852.svg";